import { Star, Shield, Medal, Hexagon, Gem, Sparkles, Crown } from "lucide-react";

// Rank order + visual meta, aligned to the business-target reward/salary chart.
export const RANK_ORDER = ["Associate", "Starter", "Bronze", "Silver", "Gold", "Platinum", "Diamond", "Elite", "Crown", "Royal", "Ambassador", "President"];

export const RANK_META = {
  Associate: { color: "#9aa4b2", Icon: Shield },
  Starter: { color: "#3b82f6", Icon: Star },
  Bronze: { color: "#cd7f32", Icon: Shield },
  Silver: { color: "#9ca3af", Icon: Shield },
  Gold: { color: "#e6c15a", Icon: Medal },
  Platinum: { color: "#60a5fa", Icon: Hexagon },
  Diamond: { color: "#22d3ee", Icon: Gem },
  Elite: { color: "#22c55e", Icon: Sparkles },
  Crown: { color: "#7c3aed", Icon: Crown },
  Royal: { color: "#ef4444", Icon: Crown },
  Ambassador: { color: "#d99a1c", Icon: Crown },
  President: { color: "#2563eb", Icon: Crown },
};

export const rankMeta = (name) => RANK_META[name] || RANK_META.Associate;
